import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { incrementStep, setAppData } from '../redux/actions';
import TextInput from '../../shared/TextInput/index.jsx';
import ReactLib from '@owenscorning/react-library'
const { Shared: { EmailValidator }, Connect: { EmailChecker, FormElements: { Form } } } = ReactLib
import NextButton from '../../shared/next-button';
import ConnectUserOfframp from './connect-user-offramp';
import NoEmail from './no-email';
import { EMAIL_REGEX } from '../../shared/utils';


const EMAIL_ENTRY = 'EMAIL_ENTRY'
const EMAIL_CONTRACTOR_CHECK = 'EMAIL_CONTRACTOR_CHECK'
const EMAIL_VALIDATION = 'EMAIL_VALIDATION'
const CONNECT_USER_OFFRAMP = 'CONNECT_USER_OFFRAMP'
const EMAIL_RESENT_OFFRAMP = 'EMAIL_RESENT_OFFRAMP'
const BAD_CODE_ENTERED = 'BAD_CODE_ENTERED'
const BAD_EMAIL = 'BAD_EMAIL'
const NO_EMAIL = 'NO_EMAIL'

const STATES = {
  EMAIL_ENTRY,
  EMAIL_CONTRACTOR_CHECK,
  EMAIL_VALIDATION,
  CONNECT_USER_OFFRAMP,
  EMAIL_RESENT_OFFRAMP,
  BAD_CODE_ENTERED,
  BAD_EMAIL,
  NO_EMAIL
}

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #6D6D6D;
  }
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const Subscript = styled.a`
  cursor: pointer;
  display: block;
  font-size: 14px;
  margin: 0;
  padding-top: 1.5rem;
  text-align: center;
  text-decoration: underline;
  width: 100%;
`;

const EmailValidationWrapper = styled.div`
  input {
    box-sizing: border-box;
    border: 1px solid #585858;
    height: 3.5em;
    margin-bottom: 1px;
    padding: 0.5em;
    width: 100%;
  }
  button {
    box-sizing: border-box;
    background-color: #D40F7D;
    border: none;
    color: #FFFFFF;
    cursor: pointer;
    font-size: 18px;
    padding: .5rem;
    width: 100%;
    margin-top: 1.5rem;

    :disabled {
      background-color: #D8D8D8;
      cursor: default;
    }
  }
`

const mapStateToProps = state => (
  {
    formData: state.formData,
    appData: state.appData,
  }
);

const emailEntry = ({ formData, setSubState, badEmail = false }) => {
  const submitEmail = () => setSubState(STATES.EMAIL_CONTRACTOR_CHECK)

  return (
    <Form onSubmit={submitEmail} data={formData}>
      <p>To get your warranty registered, we’ll need a little bit of information from you, first</p>
      <Header>What's your email?</Header>
      <Form.Requirement requireFunc={({ email }) => [(email && EMAIL_REGEX.test(email)), '']} >
        <TextInput
          fieldKey={'email'}
          htmlAttributes={{
            placeholder: 'Email Address',
          }}
        />
      </Form.Requirement>
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 2 - what's your email"
       />
      <Subscript
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 2 - what's your email"
       onClick={() => setSubState(STATES.NO_EMAIL)}>I don't have an email address</Subscript>
    </Form>
  )
}

const emailContractorCheck = ({ formData, setSubState }) => {
  const { email } = formData
  const onConnecUserDetected = () => setSubState(STATES.CONNECT_USER_OFFRAMP)
  const onPublicUserDetected = () => setSubState(STATES.EMAIL_VALIDATION)

  return (
    <EmailChecker
      mdmsUrl={MDMS_URL}
      email={email}
      onConnectUserDetected={onConnecUserDetected}
      onPublicUserDetected={onPublicUserDetected}
    />
  )
}

const emailResentOfframp = () => {
  return (
    <>
      <p>Please contact one of our representatives at:</p>
      <Header>1-800-ROOFING</Header>
    </>
  )
}

const emailValidation = ({ formData, setSubState, incrementStep, badCode = false, resendEmail }) => {
  const { email } = formData
  if (badCode) {
    _satellite.track('form-error', { errorCode: 'NA', errorMsg: "Code you entered doesn't match what we sent" });

    var instructionsCopy = <>
      <p>We're sorry, the code you entered doesn't match what we sent</p>
      <Header>Try entering the code again</Header>
    </>
  } else {
    var instructionsCopy = <>
      <p>Great! Before we continue, please enter the code we just sent to...</p>
      <Header>{email}</Header>
    </>
  }


  const onValidationComplete = () => incrementStep()
  const onValidationIncorrect = () => {

    setSubState(STATES.BAD_CODE_ENTERED)
  }
  const onBadEmail = () => setSubState(STATES.BAD_EMAIL)
  const analytics = {
    "data-track": "form-advance",
    "data-track-form-name": "Warranty Form",
    "data-track-form-step": "email validation"
  }
  return (
    <EmailValidationWrapper>
      <EmailValidator
        mdmsUrl={MDMS_URL}
        {...{ email, instructionsCopy, onValidationComplete, onValidationIncorrect, onBadEmail, analytics }}
      />
      <Subscript
      data-track="form-advance"
      data-track-form-name="Warranty Registration"
      data-track-form-step="step 2 - didn't receive a confirmation email"
      onClick={resendEmail}>I didn't receive a confirmation email</Subscript>
    </EmailValidationWrapper>
  )
}


const Step2 = ({ incrementStep, formData, setAppData, appData }) => {
  const [subState, setSubState] = useState(STATES.EMAIL_ENTRY)
  const wasResent = !!appData.emailResent
  const resendEmail = () => {
    if (wasResent) {
      setSubState(STATES.EMAIL_RESENT_OFFRAMP)
    } else {
      setAppData({emailResent: true})
      setSubState(STATES.EMAIL_ENTRY)
    }
  }

  switch (subState) {
    case STATES.EMAIL_ENTRY:
      var subStateNode = emailEntry({ formData, setSubState })
      break
    case STATES.EMAIL_CONTRACTOR_CHECK:
      var subStateNode = emailContractorCheck({ formData, setSubState })
      break
    case STATES.CONNECT_USER_OFFRAMP:
      var subStateNode = <ConnectUserOfframp returnToStep={() => setSubState(STATES.EMAIL_ENTRY)} />
      break
    case STATES.EMAIL_VALIDATION:
      var subStateNode = emailValidation({ formData, setSubState, incrementStep, resendEmail })
      break
    case STATES.EMAIL_RESENT_OFFRAMP:
      var subStateNode = emailResentOfframp()
      break
    case STATES.BAD_CODE_ENTERED:
      var subStateNode = emailValidation({ formData, setSubState, incrementStep, badCode: true })
      break
    case STATES.BAD_EMAIL:
      var subStateNode = emailEntry({ formData, setSubState, badEmail: true })
      break
    case STATES.NO_EMAIL:
      var subStateNode = <NoEmail />
      break
    default:
      throw `subState, ${subState}, not recoginzed`
  }
  console.log({ subStateNode })
  return (
    <StepWrapper>
      {
        subStateNode
      }
    </StepWrapper>
  )
};

const mapDispatchToProps = dispatch => (
  {
    incrementStep: () => dispatch(incrementStep()),
    setAppData: hash => dispatch(setAppData(hash))
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step2);
